import { IStackProps, ITextProps, Separator, Stack, Text, useTheme } from "@fluentui/react";
import { useMemo } from "react";

export enum ESectionItemVariant {
    Default,
    Drawer,
}

export interface ISectionItemProps {
    title: string;
    children: JSX.Element | JSX.Element[];
    variant?: ESectionItemVariant;
}

const SectionItem: React.FunctionComponent<ISectionItemProps> = (props) => {

    const theme = useTheme();

    const { columnProps, textProps } = useMemo(() => {
        const columnProps: Partial<IStackProps> = {
            tokens: { childrenGap: 15 },
            styles: {
                root: {
                    // width: 600,
                    // width:'98%',
                    // minWidth:'97%',
                    width: '100%',
                    boxShadow: theme.effects.elevation8,
                    padding: '10px 20px 20px 20px',
                    margin: '20px 0px 0px 0px',
                    backgroundColor: theme.semanticColors.menuBackground,
                    borderRadius: '8px',
                },
            },
        };

        const columnPropsDrawer: Partial<IStackProps> = {
            tokens: { childrenGap: 15 },
            styles: {
                root: {
                    boxShadow: theme.effects.elevation16,
                    padding: '20px',
                    margin: '20px 0px 0px 0px',
                    backgroundColor: theme.semanticColors.menuBackground,
                    borderRadius: '8px',

                },
            },
        };


        const textProps: Partial<ITextProps> = {
            variant: 'medium',
            styles: {
                root: {
                    color: '#0078D7',
                    textTransform: 'uppercase',
                    fontWeight: '600',
                }
            }
        };
        return {
            columnProps: props.variant === ESectionItemVariant.Drawer ? columnPropsDrawer : columnProps,
            textProps
        };
    }, [props.variant, theme]);

    return <Stack.Item {...columnProps}>
        <Stack.Item>
            <Stack
                horizontal
                horizontalAlign='space-between'
                verticalAlign='baseline'
            >
                <Text {...textProps}>
                    {props.title}
                </Text>
            </Stack>
        </Stack.Item>
        <Separator />
        <Stack.Item>
            <Stack tokens={{ childrenGap: '10px' }}>
                {props.children}
            </Stack>
        </Stack.Item>
    </Stack.Item >
}

export default SectionItem;